var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import * as _ from "lodash";
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let HelpResource = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.legacy, "/api/ticketing");
  }
  callNewTicketAPI(driTicket) {
    return __async(this, null, function* () {
      const address = "/new";
      const result = yield this._post(driTicket, address);
      return result;
    });
  }
  uploadUserFiles(fileInfos) {
    return __async(this, null, function* () {
      const address = "/files";
      let formData = new FormData();
      _.each(fileInfos, (f) => formData.append(f.name, f.data));
      const result = yield this._postFormData(address, formData);
      return result;
    });
  }
};
HelpResource = __decorateClass([
  WPSProxyConverter()
], HelpResource);
const HelpResource$1 = new HelpResource();
export {
  HelpResource,
  HelpResource$1 as default
};
//# sourceMappingURL=HelpResource.js.map
